import React from 'react';
import { BookOpen } from 'lucide-react';
import Login from './Login';

const EbdLogin = () => (
  <Login
    redirectAfterLogin="/ebd"
    showRegisterLink={false}
    brandTitle="EBD — Igreja360"
    brandSubtitle="Escola Bíblica Dominical"
    cardDescription="Use o mesmo e-mail e senha do Igreja360"
    HeaderIcon={BookOpen}
  />
);

export default EbdLogin;
